(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[635],{

/***/ 4070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[uid]",
      function () {
        return __webpack_require__(4109);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uid_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-slicezone/index.js
var next_slicezone = __webpack_require__(8917);
// EXTERNAL MODULE: ./utils/additional-data-context.js
var additional_data_context = __webpack_require__(1623);
// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./sm-resolver.js + 141 modules
var sm_resolver = __webpack_require__(7982);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
;// CONCATENATED MODULE: ./components/EventDetailsHero/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        background: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& .MuiGrid-container": {
                height: "100%"
            }
        },
        backgroundOverlay: _defineProperty({
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 826
        }, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }),
        preTitle: (_obj = {
            padding: theme.spacing(0.5, 1),
            color: "#fff",
            zIndex: 99,
            textTransform: "uppercase",
            marginBottom: theme.spacing(3.5)
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            textAlign: "center"
        }), _obj),
        heroTitle: (_obj1 = {
            backgroundImage: "url('/eventDetailsBlueBg.svg')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "33px 32px 26px 34px",
            color: "#fff",
            textAlign: "center",
            textTransform: "uppercase",
            marginRight: 250,
            marginBottom: "-28px"
        }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2),
            marginRight: 250,
            marginBottom: "-4px"
        }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
            marginRight: 0,
            marginBottom: "-4px"
        }), _obj1),
        heroSubTitle: (_obj2 = {
            backgroundImage: "url('/eventDetailsGreenBg.svg')",
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "fit-content",
            padding: "20px 31px",
            color: "#fff",
            textAlign: "center",
            marginLeft: 250
        }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
            backgroundSize: "cover",
            padding: theme.spacing(2),
            marginLeft: 0
        }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
            marginLeft: 0
        }), _obj2),
        heroButton: _defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        }),
        eventDaysTime: (_obj3 = {
            backgroundColor: "#F4F5F6",
            backgroundImage: 'url("/patternSimpleText.svg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundBlendMode: "color-burn",
            padding: theme.spacing(10, 4),
            fontFamily: "Raleway,Assistant",
            fontSize: 42,
            fontWeight: 900,
            lineHeight: 1.09,
            textAlign: "center",
            color: "#4c4c78",
            boxShadow: "0 30px 60px 0 rgba(73, 86, 149, 0.15)",
            margin: "0px auto",
            marginTop: "-172px",
            position: "absolute",
            left: 0,
            right: 0,
            maxWidth: 1232
        }, _defineProperty(_obj3, theme.breakpoints.down("1180"), {
            margin: "0px 24px",
            marginTop: "-172px",
            padding: theme.spacing(8, 0)
        }), _defineProperty(_obj3, theme.breakpoints.down("sm"), {
            margin: "32px 16px",
            padding: theme.spacing(6, 3),
            fontSize: 34
        }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
            padding: theme.spacing(4, 2),
            fontSize: 24,
            margin: "64px 16px"
        }), _obj3)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/react-countdown-now/dist/index.es.js
var index_es = __webpack_require__(6059);
;// CONCATENATED MODULE: ./components/EventDetailsHero/index.js












var EventDetailsHero = function(param1) {
    var classes = param1.classes, eventHeroData = param1.eventHeroData;
    var ref;
    var divStyle = {};
    if (eventHeroData.data.featured_image) {
        divStyle.backgroundImage = "url('".concat(eventHeroData.data.featured_image.url, "')");
    }
    var Completionist = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.completion
        });
    };
    // Renderer callback with condition
    var renderer = function(param) {
        var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
        if (completed) {
            // Render a completed state
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Completionist, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (0,index_es/* zeroPad */.Bu)(days),
                    " Days / ",
                    (0,index_es/* zeroPad */.Bu)(hours),
                    " Hours / ",
                    (0,index_es/* zeroPad */.Bu)(minutes),
                    " ",
                    "Minutes / ",
                    (0,index_es/* zeroPad */.Bu)(seconds),
                    " Seconds"
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.background,
        style: divStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.backgroundOverlay,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.preTitle,
                            children: prismic_reactjs.RichText.asText(eventHeroData.data.title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroTitle,
                            children: prismic_reactjs.RichText.asText(eventHeroData.data.subtitle1)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.heroSubTitle,
                            children: prismic_reactjs.RichText.asText(eventHeroData.data.subtitle2)
                        }),
                        ((ref = eventHeroData.data.register_button_link) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.heroButton,
                            children: !eventHeroData.data.upcoming_or_past && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: eventHeroData.data.register_button_link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    children: prismic_reactjs.RichText.asText(eventHeroData.data.register_button_text)
                                })
                            })
                        })
                    ]
                }),
                !eventHeroData.data.upcoming_or_past && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.eventDaysTime,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                        zeroPadTime: 2,
                        date: eventHeroData.data.event_time_date_countdown,
                        renderer: renderer
                    })
                })
            ]
        })
    });
};
EventDetailsHero.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var components_EventDetailsHero = ((0,withStyles/* default */.Z)(style)(EventDetailsHero));

// EXTERNAL MODULE: ./components/Head/index.js
var Head = __webpack_require__(4394);
;// CONCATENATED MODULE: ./pages/event/[uid].js
function _uid_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _uid_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var Event = function(props) {
    var data = props.data, eventHero = props.eventHero, uid = props.uid;
    var setHeaderColor = (0,layout_context/* useLayout */.$Y)().setHeaderColor;
    (0,react.useEffect)(function() {
        if (data) {
            setHeaderColor(data.headercolor);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                data: data,
                canonical: "/event/".concat(uid)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(additional_data_context/* AdditionalDataProvider */.YZ, {
                value: props.additionalData,
                children: [
                    eventHero && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventDetailsHero, {
                        eventHeroData: eventHero
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_slicezone/* default */.Z, _objectSpread({}, props, {
                        resolver: sm_resolver/* default */.Z
                    }))
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _uid_ = (Event);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,430,100,931,675,226,416,774,888,179], function() { return __webpack_exec__(4070); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);